export default __webpack_public_path__ + "static/media/politics.f7f56584.svg";